import type { IconNames } from '@gousto-internal/citrus-react'
import type { Recipe } from '@library/menu-service'

import { convertDashToUnderscore } from '../EndlessVarietySection/utils/utils'

enum DietaryClaimIconNames {
  DairyFree = 'dairy_free',
  GlutenFree = 'gluten_free',
  NutFree = 'nut_free',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
}

export const findDietaryClaimIcon = (recipe: Recipe): IconNames | undefined => {
  const match = recipe.dietaryClaims?.find((claim) =>
    Object.values(DietaryClaimIconNames).includes(
      convertDashToUnderscore(claim.slug) as DietaryClaimIconNames,
    ),
  )

  return match ? (convertDashToUnderscore(match.slug) as IconNames) : undefined
}
